/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createShipmentLREX = /* GraphQL */ `
  mutation CreateShipmentLREX($input: ShipmentInputLambda!) {
    createShipmentLREX(input: $input) {
      shipmentID
      labelURL
      __typename
    }
  }
`;
export const createAccountLREX = /* GraphQL */ `
  mutation CreateAccountLREX($input: AccountInputLREX!) {
    createAccountLREX(input: $input) {
      account
      user
      __typename
    }
  }
`;
export const getMergedLabelsLREX = /* GraphQL */ `
  mutation GetMergedLabelsLREX($input: getMergedLabelsLREXInput!) {
    getMergedLabelsLREX(input: $input) {
      mergedPDF
      __typename
    }
  }
`;
export const emailMergedLabelsLREX = /* GraphQL */ `
  mutation EmailMergedLabelsLREX($input: getMergedLabelsLREXInput!) {
    emailMergedLabelsLREX(input: $input) {
      downloadUrl
      __typename
    }
  }
`;
export const createShipmentLambda = /* GraphQL */ `
  mutation CreateShipmentLambda($input: ShipmentInputLambda!) {
    createShipmentLambda(input: $input) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const voidShipmentLambda = /* GraphQL */ `
  mutation VoidShipmentLambda($input: voidShipmentInputLambda!) {
    voidShipmentLambda(input: $input) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const getShipmentHistoryLambda = /* GraphQL */ `
  mutation GetShipmentHistoryLambda($input: HistoryInputLambda!) {
    getShipmentHistoryLambda(input: $input) {
      shipmentHistory {
        shipmentid
        description
        shipmentStatusId
        processedDate
        processed
        notes
        createdBy
        latitude
        longitude
        signatureId
        imageURL
        customerVisible
        __typename
      }
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      __typename
    }
  }
`;
export const getAccessTokenLambda = /* GraphQL */ `
  mutation GetAccessTokenLambda($input: AccessTokenInputLambda!) {
    getAccessTokenLambda(input: $input) {
      accessToken
      __typename
    }
  }
`;
export const createShipmentLabelLambda = /* GraphQL */ `
  mutation CreateShipmentLabelLambda($input: jsreportLabelInput!) {
    createShipmentLabelLambda(input: $input) {
      labelImage
      __typename
    }
  }
`;
export const filterCurrentShipments = /* GraphQL */ `
  mutation FilterCurrentShipments($input: filterShipmentInputLambda) {
    filterCurrentShipments(input: $input) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const filterInTransitShipments = /* GraphQL */ `
  mutation FilterInTransitShipments(
    $input: filterInTransitShipmentInputLambda
  ) {
    filterInTransitShipments(input: $input) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const filterDeliveredShipments = /* GraphQL */ `
  mutation FilterDeliveredShipments(
    $input: filterDeliveredShipmentInputLambda
  ) {
    filterDeliveredShipments(input: $input) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const updateShipmentActivity = /* GraphQL */ `
  mutation UpdateShipmentActivity($input: updateShipmentActivityInputLambda) {
    updateShipmentActivity(input: $input) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const updateShipmentData = /* GraphQL */ `
  mutation UpdateShipmentData($input: updateShipmentDataInput) {
    updateShipmentData(input: $input) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const addUserToGroup = /* GraphQL */ `
  mutation AddUserToGroup($input: addUserToGroupInput!) {
    addUserToGroup(input: $input) {
      username
      groupname
      __typename
    }
  }
`;
export const removeUserFromGroup = /* GraphQL */ `
  mutation RemoveUserFromGroup($input: removeUserFromGroupInput!) {
    removeUserFromGroup(input: $input) {
      username
      groupname
      __typename
    }
  }
`;
export const getUsersGroupData = /* GraphQL */ `
  mutation GetUsersGroupData($input: getUsersGroupDataInput!) {
    getUsersGroupData(input: $input) {
      Groups {
        GroupName
        Description
        __typename
      }
      __typename
    }
  }
`;
export const listAllUserGroups = /* GraphQL */ `
  mutation ListAllUserGroups($input: getUsersGroupDataInput!) {
    listAllUserGroups(input: $input) {
      Groups {
        GroupName
        Description
        __typename
      }
      __typename
    }
  }
`;
export const getUsersAttributeData = /* GraphQL */ `
  mutation GetUsersAttributeData($input: getUsersAttributeDataInput!) {
    getUsersAttributeData(input: $input) {
      attributeData {
        Name
        Value
        __typename
      }
      __typename
    }
  }
`;
export const updateUsersAttributeData = /* GraphQL */ `
  mutation UpdateUsersAttributeData($input: updateUsersAttributeDataInput!) {
    updateUsersAttributeData(input: $input) {
      username
      __typename
    }
  }
`;
export const createCognitoUser = /* GraphQL */ `
  mutation CreateCognitoUser($input: createCognitoUserInput!) {
    createCognitoUser(input: $input) {
      username
      groupname
      __typename
    }
  }
`;
export const getShipmentDataREST = /* GraphQL */ `
  mutation GetShipmentDataREST($input: getShipmentDataRESTInput!) {
    getShipmentDataREST(input: $input) {
      shipmentID
      pickupCompanyName
      pickupAttention
      pickupAddress1
      pickupAddress2
      pickupCity
      pickupState
      pickupZipCode
      deliveryCompanyName
      deliveryAttention
      deliveryAddress1
      deliveryAddress2
      deliveryCity
      deliveryState
      deliveryZipCode
      deliveryPhone
      shipmentWeight
      deliveryInstructions
      numOfPackages
      deliveryNotifyemail
      description
      __typename
    }
  }
`;
export const createParcelP2P = /* GraphQL */ `
  mutation CreateParcelP2P($input: createParcelP2PInput!) {
    createParcelP2P(input: $input) {
      status
      UniqueParcelID
      ParcelID
      errors
      __typename
    }
  }
`;
export const cancelParcelP2P = /* GraphQL */ `
  mutation CancelParcelP2P($input: cancelParcelP2PInput!) {
    cancelParcelP2P(input: $input) {
      status
      UniqueParcelID
      ParcelID
      errors
      __typename
    }
  }
`;
export const createLabelP2P = /* GraphQL */ `
  mutation CreateLabelP2P($input: createLabelP2PInput!) {
    createLabelP2P(input: $input) {
      status
      UniqueParcelID
      TrackingNumber
      CarrierName
      LabelType
      Label
      Invoice
      errors
      __typename
    }
  }
`;
export const trackParcelP2P = /* GraphQL */ `
  mutation TrackParcelP2P($input: trackParcelP2PInput!) {
    trackParcelP2P(input: $input) {
      TrackParcel {
        trackingEventDate
        trackingEventName
        trackingEventExtra
        trackingEventCode
        trackingEventLocation
        __typename
      }
      __typename
    }
  }
`;
export const shippingQuoteP2P = /* GraphQL */ `
  mutation ShippingQuoteP2P($input: shippingQuoteP2PInput!) {
    shippingQuoteP2P(input: $input) {
      shippingQuote
      __typename
    }
  }
`;
export const manifestParcelP2P = /* GraphQL */ `
  mutation ManifestParcelP2P($input: manifestParcelP2PInput!) {
    manifestParcelP2P(input: $input) {
      status
      ManifestID
      Document
      errors
      __typename
    }
  }
`;
export const shippingDocumentP2P = /* GraphQL */ `
  mutation ShippingDocumentP2P($input: shippingDocumentP2PInput!) {
    shippingDocumentP2P(input: $input) {
      status
      Document
      errors
      __typename
    }
  }
`;
export const queryManifestShipment = /* GraphQL */ `
  mutation QueryManifestShipment($input: queryManifestShipmentInput!) {
    queryManifestShipment(input: $input) {
      shipmentIDAssignedShippingEvent
      shipmentID
      assignedShippingEvent
      assignedActivities
      address {
        address1
        address2
        attention
        city
        companyName
        phone
        latitude
        longitude
        relevance
        routeCode
        state
        zipCode
        __typename
      }
      isDelivery
      isPriority
      latitude
      longitude
      route
      status
      timeWindowEnd
      timeWindowStart
      addedOn
      externalTrackingNumber
      expectedDispatchDate
      expectedDispatchTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const queryManifestWaypoint = /* GraphQL */ `
  mutation QueryManifestWaypoint($input: queryManifestWaypointInput!) {
    queryManifestWaypoint(input: $input) {
      routeCode
      waypoint
      address {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      arrival
      assignmentRule
      deliveries
      departure
      fromPreviousDistance
      fromPreviousTravelTime
      id
      isDelivery
      isDropBox
      latitude
      longitude
      pickups
      radius
      route
      sequence
      serviceTime
      locations {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        locationID
        __typename
      }
      shipments {
        shipmentID
        signatureRequired
        isPriority
        isDelivery
        assignedShippingEvent
        assignedActivities
        additionalServices
        __typename
      }
      stop
      stopType
      violationTime
      waitTime
      windowEnd
      windowStart
      created
      distanceCost
      endTime
      error
      geometry
      jobID
      orderCount
      overTimeCost
      processed
      regularTimeCost
      routeEnd
      routeStart
      startTime
      status
      totalBreakServiceTime
      totalCost
      totalDistance
      totalOrderServiceTime
      totalTime
      totalTravelTime
      totalViolationTime
      totalWaitTime
      violatedConstraints
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const cloverCreateCustomer = /* GraphQL */ `
  mutation CloverCreateCustomer($input: cloverCreateCustomerInput!) {
    cloverCreateCustomer(input: $input) {
      status
      cloverID
      __typename
    }
  }
`;
export const cloverChargeCustomer = /* GraphQL */ `
  mutation CloverChargeCustomer($input: cloverChargeCustomerInput!) {
    cloverChargeCustomer(input: $input) {
      amount
      id
      status
      __typename
    }
  }
`;
export const cloverGetCustomer = /* GraphQL */ `
  mutation CloverGetCustomer($input: cloverGetCustomerInput!) {
    cloverGetCustomer(input: $input) {
      id
      href
      firstName
      lastName
      marketingAllowed
      customerSince
      cards {
        __typename
      }
      __typename
    }
  }
`;
export const cloverUpdateCustomer = /* GraphQL */ `
  mutation CloverUpdateCustomer($input: cloverUpdateCustomerInput!) {
    cloverUpdateCustomer(input: $input) {
      status
      cloverID
      __typename
    }
  }
`;
export const cloverRevokePaymentSource = /* GraphQL */ `
  mutation CloverRevokePaymentSource($input: cloverRevokePaymentSourceInput!) {
    cloverRevokePaymentSource(input: $input) {
      deleted
      id
      object
      __typename
    }
  }
`;
export const createShipmentUPS = /* GraphQL */ `
  mutation CreateShipmentUPS($input: UPSInputLambda!) {
    createShipmentUPS(input: $input) {
      shipmentID
      trackingNumber
      shipmentLabel
      shippingLabel
      error
      __typename
    }
  }
`;
export const createLabelUPS = /* GraphQL */ `
  mutation CreateLabelUPS($input: UPSInputLambda!) {
    createLabelUPS(input: $input) {
      shipmentID
      trackingNumber
      shipmentLabel
      shippingLabel
      error
      __typename
    }
  }
`;
export const voidShipmentUPS = /* GraphQL */ `
  mutation VoidShipmentUPS($input: UPSInputLambda!) {
    voidShipmentUPS(input: $input) {
      shipmentID
      trackingNumber
      shipmentLabel
      shippingLabel
      error
      __typename
    }
  }
`;
export const manifestCreateTrip = /* GraphQL */ `
  mutation ManifestCreateTrip($input: manifestCreateTripInput!) {
    manifestCreateTrip(input: $input) {
      tripSheetID
      __typename
    }
  }
`;
export const manifestOptimise = /* GraphQL */ `
  mutation ManifestOptimise($input: manifestOptimiseInput!) {
    manifestOptimise(input: $input) {
      routeCode
      jobID
      __typename
    }
  }
`;
export const getOpenTripSheet = /* GraphQL */ `
  mutation GetOpenTripSheet($input: getOpenTripSheetInput!) {
    getOpenTripSheet(input: $input) {
      TripSheetId
      DriverId
      RouteId
      VehicleId
      TripDate
      SignOffDate
      StartingMileage
      SignOffId
      EndingMileage
      ManifestSource
      driverCode
      routeCode
      vehicleCode
      openSince
      closedOn
      __typename
    }
  }
`;
export const getStripeCustomerPortal = /* GraphQL */ `
  mutation GetStripeCustomerPortal($input: getStripeCustomerPortalInput!) {
    getStripeCustomerPortal(input: $input) {
      sessionURL
      __typename
    }
  }
`;
export const createStripeCustomer = /* GraphQL */ `
  mutation CreateStripeCustomer($input: createStripeCustomerInput!) {
    createStripeCustomer(input: $input) {
      stripeID
      __typename
    }
  }
`;
export const createCheckoutSession = /* GraphQL */ `
  mutation CreateCheckoutSession($input: createCheckoutSessionInput!) {
    createCheckoutSession(input: $input) {
      sessionURL
      __typename
    }
  }
`;
export const chargeStripeCustomer = /* GraphQL */ `
  mutation ChargeStripeCustomer($input: chargeStripeCustomerInput!) {
    chargeStripeCustomer(input: $input) {
      id
      amount_received
      status
      __typename
    }
  }
`;
export const generateInvoicePDF = /* GraphQL */ `
  mutation GenerateInvoicePDF($input: generateInvoicePDFInput!) {
    generateInvoicePDF(input: $input) {
      invoicePDF
      __typename
    }
  }
`;
export const queryOpenSearchShipment = /* GraphQL */ `
  mutation QueryOpenSearchShipment($input: SearchInput!) {
    queryOpenSearchShipment(input: $input) {
      shipmentResult {
        username
        owner
        accountNo
        secretKey
        service
        totalPrice
        totalCost
        shipmentID
        ref1
        ref2
        ref3
        ref4
        ref5
        additionalRefs
        description
        deliveryInstructions
        weight
        packageCount
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        additionalServices
        isContractedDelivery
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        labelImage
        deliveryDay
        voidAt
        currentKey
        historyKey
        inTransitKey
        voidKey
        pickupInitiated
        isPickup
        createdAt
        updatedAt
        processError
        apiKey
        externalTrackingNumber
        expiresAt
        shippedAt
        deliveredAt
        signedLabelURL
        originalServiceAddress
        __typename
      }
      searchAfterValue
      __typename
    }
  }
`;
export const queryOpenSearchFilter = /* GraphQL */ `
  mutation QueryOpenSearchFilter($input: SearchInput!) {
    queryOpenSearchFilter(input: $input) {
      filterResult
      searchAfterValue
      __typename
    }
  }
`;
export const resolvePlace = /* GraphQL */ `
  mutation ResolvePlace($input: ResolvePlaceInput!) {
    resolvePlace(input: $input) {
      placeID
      placeCode
      latitude
      longitude
      relevance
      address1
      address2
      city
      state
      zipCode
      serviceAddressType
      operatorTitle
      timeWindowStart
      timeWindowEnd
      timeWindowType
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      __typename
    }
  }
`;
export const addToTrip = /* GraphQL */ `
  mutation AddToTrip($input: AddToTripInput!) {
    addToTrip(input: $input) {
      statusCode
      status
      body
      __typename
    }
  }
`;
export const createAccount = /* GraphQL */ `
  mutation CreateAccount(
    $input: CreateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    createAccount(input: $input, condition: $condition) {
      accountNo
      accountType
      contact1
      contact2
      contact3
      defaultWeight
      balance
      creditLimit
      billable
      contractedLocations
      specialPricing
      billRunDate
      billFrequency
      industry
      product {
        productCode
        serviceCode
        description
        additionalService
        serviceNetwork
        vendor
        price
        productName
        restServiceCode
        descriptionUI
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        productFamily
        serviceGroup
        serviceGroupSequence
        productSequence
        fuelSurchargeCode
        useTaxCode
        getCost
        quantity
        DiscountType
        discountAmount
        __typename
      }
      billingAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      locationID
      locationAddress {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      billType
      fuelSurcharge {
        fuelSurchargeCode
        fuelSurchargeRate
        specialRate
        __typename
      }
      cardOnFileCount
      stripeID
      paymentMethods
      defaultPaymentMethodType
      invoiceEmails
      paymentDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      accountNo
      accountType
      contact1
      contact2
      contact3
      defaultWeight
      balance
      creditLimit
      billable
      contractedLocations
      specialPricing
      billRunDate
      billFrequency
      industry
      product {
        productCode
        serviceCode
        description
        additionalService
        serviceNetwork
        vendor
        price
        productName
        restServiceCode
        descriptionUI
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        productFamily
        serviceGroup
        serviceGroupSequence
        productSequence
        fuelSurchargeCode
        useTaxCode
        getCost
        quantity
        DiscountType
        discountAmount
        __typename
      }
      billingAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      locationID
      locationAddress {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      billType
      fuelSurcharge {
        fuelSurchargeCode
        fuelSurchargeRate
        specialRate
        __typename
      }
      cardOnFileCount
      stripeID
      paymentMethods
      defaultPaymentMethodType
      invoiceEmails
      paymentDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount(
    $input: DeleteAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    deleteAccount(input: $input, condition: $condition) {
      accountNo
      accountType
      contact1
      contact2
      contact3
      defaultWeight
      balance
      creditLimit
      billable
      contractedLocations
      specialPricing
      billRunDate
      billFrequency
      industry
      product {
        productCode
        serviceCode
        description
        additionalService
        serviceNetwork
        vendor
        price
        productName
        restServiceCode
        descriptionUI
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        productFamily
        serviceGroup
        serviceGroupSequence
        productSequence
        fuelSurchargeCode
        useTaxCode
        getCost
        quantity
        DiscountType
        discountAmount
        __typename
      }
      billingAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      locationID
      locationAddress {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      billType
      fuelSurcharge {
        fuelSurchargeCode
        fuelSurchargeRate
        specialRate
        __typename
      }
      cardOnFileCount
      stripeID
      paymentMethods
      defaultPaymentMethodType
      invoiceEmails
      paymentDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSequentialCounter = /* GraphQL */ `
  mutation CreateSequentialCounter(
    $input: CreateSequentialCounterInput!
    $condition: ModelSequentialCounterConditionInput
  ) {
    createSequentialCounter(input: $input, condition: $condition) {
      counterCode
      counterValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSequentialCounter = /* GraphQL */ `
  mutation UpdateSequentialCounter(
    $input: UpdateSequentialCounterInput!
    $condition: ModelSequentialCounterConditionInput
  ) {
    updateSequentialCounter(input: $input, condition: $condition) {
      counterCode
      counterValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSequentialCounter = /* GraphQL */ `
  mutation DeleteSequentialCounter(
    $input: DeleteSequentialCounterInput!
    $condition: ModelSequentialCounterConditionInput
  ) {
    deleteSequentialCounter(input: $input, condition: $condition) {
      counterCode
      counterValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAddressBook = /* GraphQL */ `
  mutation CreateAddressBook(
    $input: CreateAddressBookInput!
    $condition: ModelAddressBookConditionInput
  ) {
    createAddressBook(input: $input, condition: $condition) {
      id
      userName
      accountNo
      companyName
      attention
      address1
      address2
      city
      state
      zipCode
      routeCode
      plusFour
      phone
      phoneExt
      email
      latitude
      longitude
      deliveryInstructions
      relevance
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateAddressBook = /* GraphQL */ `
  mutation UpdateAddressBook(
    $input: UpdateAddressBookInput!
    $condition: ModelAddressBookConditionInput
  ) {
    updateAddressBook(input: $input, condition: $condition) {
      id
      userName
      accountNo
      companyName
      attention
      address1
      address2
      city
      state
      zipCode
      routeCode
      plusFour
      phone
      phoneExt
      email
      latitude
      longitude
      deliveryInstructions
      relevance
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteAddressBook = /* GraphQL */ `
  mutation DeleteAddressBook(
    $input: DeleteAddressBookInput!
    $condition: ModelAddressBookConditionInput
  ) {
    deleteAddressBook(input: $input, condition: $condition) {
      id
      userName
      accountNo
      companyName
      attention
      address1
      address2
      city
      state
      zipCode
      routeCode
      plusFour
      phone
      phoneExt
      email
      latitude
      longitude
      deliveryInstructions
      relevance
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createLocation = /* GraphQL */ `
  mutation CreateLocation(
    $input: CreateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    createLocation(input: $input, condition: $condition) {
      id
      accountNo
      serviceAddress {
        type
        location
        __typename
      }
      labelImage
      isContractedPickup
      isCustomerPickup
      isContractedDelivery
      isDefaultLocation
      isUser
      contractedLocation {
        pickupWindowEnd
        pickupWindowStart
        username
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        ref1
        productCode
        deliveryInstructions
        additionalServices
        __typename
      }
      placeID
      place {
        placeCode
        address1
        address2
        city
        state
        zipCode
        relevance
        latitude
        longitude
        pickupRoute
        radius
        pickupWindowEnd
        pickupWindowStart
        serviceTime
        createdAt
        updatedAt
        owner
        __typename
      }
      placePickupTime
      routeCode
      route {
        routeCode
        routeId
        breakDuration
        breakWindowEnd
        breakWindowStart
        costPerUnitDistance
        costPerUnitTime
        earliestStartTime
        endDepot
        latestStartTime
        maxTotalTime
        startDepot
        timeWindowStart
        timeWindowEnd
        openManifestAction
        manifestCutoffTime
        manifestStatus
        driver
        createdAt
        updatedAt
        owner
        __typename
      }
      primeRxLocation
      canManifest
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateLocation = /* GraphQL */ `
  mutation UpdateLocation(
    $input: UpdateLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    updateLocation(input: $input, condition: $condition) {
      id
      accountNo
      serviceAddress {
        type
        location
        __typename
      }
      labelImage
      isContractedPickup
      isCustomerPickup
      isContractedDelivery
      isDefaultLocation
      isUser
      contractedLocation {
        pickupWindowEnd
        pickupWindowStart
        username
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        ref1
        productCode
        deliveryInstructions
        additionalServices
        __typename
      }
      placeID
      place {
        placeCode
        address1
        address2
        city
        state
        zipCode
        relevance
        latitude
        longitude
        pickupRoute
        radius
        pickupWindowEnd
        pickupWindowStart
        serviceTime
        createdAt
        updatedAt
        owner
        __typename
      }
      placePickupTime
      routeCode
      route {
        routeCode
        routeId
        breakDuration
        breakWindowEnd
        breakWindowStart
        costPerUnitDistance
        costPerUnitTime
        earliestStartTime
        endDepot
        latestStartTime
        maxTotalTime
        startDepot
        timeWindowStart
        timeWindowEnd
        openManifestAction
        manifestCutoffTime
        manifestStatus
        driver
        createdAt
        updatedAt
        owner
        __typename
      }
      primeRxLocation
      canManifest
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteLocation = /* GraphQL */ `
  mutation DeleteLocation(
    $input: DeleteLocationInput!
    $condition: ModelLocationConditionInput
  ) {
    deleteLocation(input: $input, condition: $condition) {
      id
      accountNo
      serviceAddress {
        type
        location
        __typename
      }
      labelImage
      isContractedPickup
      isCustomerPickup
      isContractedDelivery
      isDefaultLocation
      isUser
      contractedLocation {
        pickupWindowEnd
        pickupWindowStart
        username
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        ref1
        productCode
        deliveryInstructions
        additionalServices
        __typename
      }
      placeID
      place {
        placeCode
        address1
        address2
        city
        state
        zipCode
        relevance
        latitude
        longitude
        pickupRoute
        radius
        pickupWindowEnd
        pickupWindowStart
        serviceTime
        createdAt
        updatedAt
        owner
        __typename
      }
      placePickupTime
      routeCode
      route {
        routeCode
        routeId
        breakDuration
        breakWindowEnd
        breakWindowStart
        costPerUnitDistance
        costPerUnitTime
        earliestStartTime
        endDepot
        latestStartTime
        maxTotalTime
        startDepot
        timeWindowStart
        timeWindowEnd
        openManifestAction
        manifestCutoffTime
        manifestStatus
        driver
        createdAt
        updatedAt
        owner
        __typename
      }
      primeRxLocation
      canManifest
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createPlace = /* GraphQL */ `
  mutation CreatePlace(
    $input: CreatePlaceInput!
    $condition: ModelPlaceConditionInput
  ) {
    createPlace(input: $input, condition: $condition) {
      placeCode
      address1
      address2
      city
      state
      zipCode
      relevance
      latitude
      longitude
      pickupRoute
      radius
      pickupWindowEnd
      pickupWindowStart
      serviceTime
      route {
        routeCode
        routeId
        breakDuration
        breakWindowEnd
        breakWindowStart
        costPerUnitDistance
        costPerUnitTime
        earliestStartTime
        endDepot
        latestStartTime
        maxTotalTime
        startDepot
        timeWindowStart
        timeWindowEnd
        openManifestAction
        manifestCutoffTime
        manifestStatus
        driver
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updatePlace = /* GraphQL */ `
  mutation UpdatePlace(
    $input: UpdatePlaceInput!
    $condition: ModelPlaceConditionInput
  ) {
    updatePlace(input: $input, condition: $condition) {
      placeCode
      address1
      address2
      city
      state
      zipCode
      relevance
      latitude
      longitude
      pickupRoute
      radius
      pickupWindowEnd
      pickupWindowStart
      serviceTime
      route {
        routeCode
        routeId
        breakDuration
        breakWindowEnd
        breakWindowStart
        costPerUnitDistance
        costPerUnitTime
        earliestStartTime
        endDepot
        latestStartTime
        maxTotalTime
        startDepot
        timeWindowStart
        timeWindowEnd
        openManifestAction
        manifestCutoffTime
        manifestStatus
        driver
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deletePlace = /* GraphQL */ `
  mutation DeletePlace(
    $input: DeletePlaceInput!
    $condition: ModelPlaceConditionInput
  ) {
    deletePlace(input: $input, condition: $condition) {
      placeCode
      address1
      address2
      city
      state
      zipCode
      relevance
      latitude
      longitude
      pickupRoute
      radius
      pickupWindowEnd
      pickupWindowStart
      serviceTime
      route {
        routeCode
        routeId
        breakDuration
        breakWindowEnd
        breakWindowStart
        costPerUnitDistance
        costPerUnitTime
        earliestStartTime
        endDepot
        latestStartTime
        maxTotalTime
        startDepot
        timeWindowStart
        timeWindowEnd
        openManifestAction
        manifestCutoffTime
        manifestStatus
        driver
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      productCode
      serviceCode
      description
      additionalService
      serviceNetwork
      vendor
      price
      productName
      restServiceCode
      descriptionUI
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      productFamily
      serviceGroup
      serviceGroupSequence
      productSequence
      fuelSurchargeCode
      useTaxCode
      getCost
      defaultProduct
      discontinued
      quantity
      DiscountType
      discountAmount
      isDiscount
      useADV
      includedProducts {
        productCode
        serviceCode
        __typename
      }
      tierPrice {
        start
        end
        price
        slab
        allowed
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      productCode
      serviceCode
      description
      additionalService
      serviceNetwork
      vendor
      price
      productName
      restServiceCode
      descriptionUI
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      productFamily
      serviceGroup
      serviceGroupSequence
      productSequence
      fuelSurchargeCode
      useTaxCode
      getCost
      defaultProduct
      discontinued
      quantity
      DiscountType
      discountAmount
      isDiscount
      useADV
      includedProducts {
        productCode
        serviceCode
        __typename
      }
      tierPrice {
        start
        end
        price
        slab
        allowed
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      productCode
      serviceCode
      description
      additionalService
      serviceNetwork
      vendor
      price
      productName
      restServiceCode
      descriptionUI
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      productFamily
      serviceGroup
      serviceGroupSequence
      productSequence
      fuelSurchargeCode
      useTaxCode
      getCost
      defaultProduct
      discontinued
      quantity
      DiscountType
      discountAmount
      isDiscount
      useADV
      includedProducts {
        productCode
        serviceCode
        __typename
      }
      tierPrice {
        start
        end
        price
        slab
        allowed
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createProductCode = /* GraphQL */ `
  mutation CreateProductCode(
    $input: CreateProductCodeInput!
    $condition: ModelProductCodeConditionInput
  ) {
    createProductCode(input: $input, condition: $condition) {
      productCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateProductCode = /* GraphQL */ `
  mutation UpdateProductCode(
    $input: UpdateProductCodeInput!
    $condition: ModelProductCodeConditionInput
  ) {
    updateProductCode(input: $input, condition: $condition) {
      productCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteProductCode = /* GraphQL */ `
  mutation DeleteProductCode(
    $input: DeleteProductCodeInput!
    $condition: ModelProductCodeConditionInput
  ) {
    deleteProductCode(input: $input, condition: $condition) {
      productCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createServiceCode = /* GraphQL */ `
  mutation CreateServiceCode(
    $input: CreateServiceCodeInput!
    $condition: ModelServiceCodeConditionInput
  ) {
    createServiceCode(input: $input, condition: $condition) {
      serviceCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateServiceCode = /* GraphQL */ `
  mutation UpdateServiceCode(
    $input: UpdateServiceCodeInput!
    $condition: ModelServiceCodeConditionInput
  ) {
    updateServiceCode(input: $input, condition: $condition) {
      serviceCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteServiceCode = /* GraphQL */ `
  mutation DeleteServiceCode(
    $input: DeleteServiceCodeInput!
    $condition: ModelServiceCodeConditionInput
  ) {
    deleteServiceCode(input: $input, condition: $condition) {
      serviceCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createServiceNetwork = /* GraphQL */ `
  mutation CreateServiceNetwork(
    $input: CreateServiceNetworkInput!
    $condition: ModelServiceNetworkConditionInput
  ) {
    createServiceNetwork(input: $input, condition: $condition) {
      serviceNetwork
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateServiceNetwork = /* GraphQL */ `
  mutation UpdateServiceNetwork(
    $input: UpdateServiceNetworkInput!
    $condition: ModelServiceNetworkConditionInput
  ) {
    updateServiceNetwork(input: $input, condition: $condition) {
      serviceNetwork
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteServiceNetwork = /* GraphQL */ `
  mutation DeleteServiceNetwork(
    $input: DeleteServiceNetworkInput!
    $condition: ModelServiceNetworkConditionInput
  ) {
    deleteServiceNetwork(input: $input, condition: $condition) {
      serviceNetwork
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createVendor = /* GraphQL */ `
  mutation CreateVendor(
    $input: CreateVendorInput!
    $condition: ModelVendorConditionInput
  ) {
    createVendor(input: $input, condition: $condition) {
      vendor
      vendorName
      status
      phoneNumber
      email
      fuelSurcharge
      billFrequency
      billRunDate
      invoiceSequence
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateVendor = /* GraphQL */ `
  mutation UpdateVendor(
    $input: UpdateVendorInput!
    $condition: ModelVendorConditionInput
  ) {
    updateVendor(input: $input, condition: $condition) {
      vendor
      vendorName
      status
      phoneNumber
      email
      fuelSurcharge
      billFrequency
      billRunDate
      invoiceSequence
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteVendor = /* GraphQL */ `
  mutation DeleteVendor(
    $input: DeleteVendorInput!
    $condition: ModelVendorConditionInput
  ) {
    deleteVendor(input: $input, condition: $condition) {
      vendor
      vendorName
      status
      phoneNumber
      email
      fuelSurcharge
      billFrequency
      billRunDate
      invoiceSequence
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createVendorInvoice = /* GraphQL */ `
  mutation CreateVendorInvoice(
    $input: CreateVendorInvoiceInput!
    $condition: ModelVendorInvoiceConditionInput
  ) {
    createVendorInvoice(input: $input, condition: $condition) {
      vendorInvoiceID
      vendor
      sequence
      vendorName
      status
      invoiceTotal
      fuelSurcharge
      invoicePostDate
      exportedOn
      s3Key
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateVendorInvoice = /* GraphQL */ `
  mutation UpdateVendorInvoice(
    $input: UpdateVendorInvoiceInput!
    $condition: ModelVendorInvoiceConditionInput
  ) {
    updateVendorInvoice(input: $input, condition: $condition) {
      vendorInvoiceID
      vendor
      sequence
      vendorName
      status
      invoiceTotal
      fuelSurcharge
      invoicePostDate
      exportedOn
      s3Key
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteVendorInvoice = /* GraphQL */ `
  mutation DeleteVendorInvoice(
    $input: DeleteVendorInvoiceInput!
    $condition: ModelVendorInvoiceConditionInput
  ) {
    deleteVendorInvoice(input: $input, condition: $condition) {
      vendorInvoiceID
      vendor
      sequence
      vendorName
      status
      invoiceTotal
      fuelSurcharge
      invoicePostDate
      exportedOn
      s3Key
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createVendorInvoiceLine = /* GraphQL */ `
  mutation CreateVendorInvoiceLine(
    $input: CreateVendorInvoiceLineInput!
    $condition: ModelVendorInvoiceLineConditionInput
  ) {
    createVendorInvoiceLine(input: $input, condition: $condition) {
      vendorInvoiceID
      lineNo
      vendor
      tripSheetID
      tripDate
      routeCode
      driverCode
      productCode
      serviceCode
      description
      quantity
      price
      amount
      fuelSurchargeCode
      fuelSurchargeRate
      fuelSurcharge
      total
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateVendorInvoiceLine = /* GraphQL */ `
  mutation UpdateVendorInvoiceLine(
    $input: UpdateVendorInvoiceLineInput!
    $condition: ModelVendorInvoiceLineConditionInput
  ) {
    updateVendorInvoiceLine(input: $input, condition: $condition) {
      vendorInvoiceID
      lineNo
      vendor
      tripSheetID
      tripDate
      routeCode
      driverCode
      productCode
      serviceCode
      description
      quantity
      price
      amount
      fuelSurchargeCode
      fuelSurchargeRate
      fuelSurcharge
      total
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteVendorInvoiceLine = /* GraphQL */ `
  mutation DeleteVendorInvoiceLine(
    $input: DeleteVendorInvoiceLineInput!
    $condition: ModelVendorInvoiceLineConditionInput
  ) {
    deleteVendorInvoiceLine(input: $input, condition: $condition) {
      vendorInvoiceID
      lineNo
      vendor
      tripSheetID
      tripDate
      routeCode
      driverCode
      productCode
      serviceCode
      description
      quantity
      price
      amount
      fuelSurchargeCode
      fuelSurchargeRate
      fuelSurcharge
      total
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createRestServiceCode = /* GraphQL */ `
  mutation CreateRestServiceCode(
    $input: CreateRestServiceCodeInput!
    $condition: ModelRestServiceCodeConditionInput
  ) {
    createRestServiceCode(input: $input, condition: $condition) {
      restServiceCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateRestServiceCode = /* GraphQL */ `
  mutation UpdateRestServiceCode(
    $input: UpdateRestServiceCodeInput!
    $condition: ModelRestServiceCodeConditionInput
  ) {
    updateRestServiceCode(input: $input, condition: $condition) {
      restServiceCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteRestServiceCode = /* GraphQL */ `
  mutation DeleteRestServiceCode(
    $input: DeleteRestServiceCodeInput!
    $condition: ModelRestServiceCodeConditionInput
  ) {
    deleteRestServiceCode(input: $input, condition: $condition) {
      restServiceCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createProductFamily = /* GraphQL */ `
  mutation CreateProductFamily(
    $input: CreateProductFamilyInput!
    $condition: ModelProductFamilyConditionInput
  ) {
    createProductFamily(input: $input, condition: $condition) {
      productFamily
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateProductFamily = /* GraphQL */ `
  mutation UpdateProductFamily(
    $input: UpdateProductFamilyInput!
    $condition: ModelProductFamilyConditionInput
  ) {
    updateProductFamily(input: $input, condition: $condition) {
      productFamily
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteProductFamily = /* GraphQL */ `
  mutation DeleteProductFamily(
    $input: DeleteProductFamilyInput!
    $condition: ModelProductFamilyConditionInput
  ) {
    deleteProductFamily(input: $input, condition: $condition) {
      productFamily
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createServiceGroup = /* GraphQL */ `
  mutation CreateServiceGroup(
    $input: CreateServiceGroupInput!
    $condition: ModelServiceGroupConditionInput
  ) {
    createServiceGroup(input: $input, condition: $condition) {
      serviceGroup
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateServiceGroup = /* GraphQL */ `
  mutation UpdateServiceGroup(
    $input: UpdateServiceGroupInput!
    $condition: ModelServiceGroupConditionInput
  ) {
    updateServiceGroup(input: $input, condition: $condition) {
      serviceGroup
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteServiceGroup = /* GraphQL */ `
  mutation DeleteServiceGroup(
    $input: DeleteServiceGroupInput!
    $condition: ModelServiceGroupConditionInput
  ) {
    deleteServiceGroup(input: $input, condition: $condition) {
      serviceGroup
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createRoute = /* GraphQL */ `
  mutation CreateRoute(
    $input: CreateRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    createRoute(input: $input, condition: $condition) {
      routeCode
      routeId
      breakDuration
      breakWindowEnd
      breakWindowStart
      costPerUnitDistance
      costPerUnitTime
      earliestStartTime
      endDepot
      latestStartTime
      maxTotalTime
      startDepot
      timeWindowStart
      timeWindowEnd
      openManifestAction
      manifestCutoffTime
      manifestStatus
      driver
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateRoute = /* GraphQL */ `
  mutation UpdateRoute(
    $input: UpdateRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    updateRoute(input: $input, condition: $condition) {
      routeCode
      routeId
      breakDuration
      breakWindowEnd
      breakWindowStart
      costPerUnitDistance
      costPerUnitTime
      earliestStartTime
      endDepot
      latestStartTime
      maxTotalTime
      startDepot
      timeWindowStart
      timeWindowEnd
      openManifestAction
      manifestCutoffTime
      manifestStatus
      driver
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteRoute = /* GraphQL */ `
  mutation DeleteRoute(
    $input: DeleteRouteInput!
    $condition: ModelRouteConditionInput
  ) {
    deleteRoute(input: $input, condition: $condition) {
      routeCode
      routeId
      breakDuration
      breakWindowEnd
      breakWindowStart
      costPerUnitDistance
      costPerUnitTime
      earliestStartTime
      endDepot
      latestStartTime
      maxTotalTime
      startDepot
      timeWindowStart
      timeWindowEnd
      openManifestAction
      manifestCutoffTime
      manifestStatus
      driver
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createGeoServiceNetwork = /* GraphQL */ `
  mutation CreateGeoServiceNetwork(
    $input: CreateGeoServiceNetworkInput!
    $condition: ModelGeoServiceNetworkConditionInput
  ) {
    createGeoServiceNetwork(input: $input, condition: $condition) {
      geoCode
      routeCode
      serviceNetwork
      products {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateGeoServiceNetwork = /* GraphQL */ `
  mutation UpdateGeoServiceNetwork(
    $input: UpdateGeoServiceNetworkInput!
    $condition: ModelGeoServiceNetworkConditionInput
  ) {
    updateGeoServiceNetwork(input: $input, condition: $condition) {
      geoCode
      routeCode
      serviceNetwork
      products {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteGeoServiceNetwork = /* GraphQL */ `
  mutation DeleteGeoServiceNetwork(
    $input: DeleteGeoServiceNetworkInput!
    $condition: ModelGeoServiceNetworkConditionInput
  ) {
    deleteGeoServiceNetwork(input: $input, condition: $condition) {
      geoCode
      routeCode
      serviceNetwork
      products {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createDropBox = /* GraphQL */ `
  mutation CreateDropBox(
    $input: CreateDropBoxInput!
    $condition: ModelDropBoxConditionInput
  ) {
    createDropBox(input: $input, condition: $condition) {
      dropBoxCode
      isActive
      serviceAddress {
        type
        location
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateDropBox = /* GraphQL */ `
  mutation UpdateDropBox(
    $input: UpdateDropBoxInput!
    $condition: ModelDropBoxConditionInput
  ) {
    updateDropBox(input: $input, condition: $condition) {
      dropBoxCode
      isActive
      serviceAddress {
        type
        location
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteDropBox = /* GraphQL */ `
  mutation DeleteDropBox(
    $input: DeleteDropBoxInput!
    $condition: ModelDropBoxConditionInput
  ) {
    deleteDropBox(input: $input, condition: $condition) {
      dropBoxCode
      isActive
      serviceAddress {
        type
        location
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createVehicle = /* GraphQL */ `
  mutation CreateVehicle(
    $input: CreateVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    createVehicle(input: $input, condition: $condition) {
      vehicleCode
      isActive
      plateNumber
      vehicleID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateVehicle = /* GraphQL */ `
  mutation UpdateVehicle(
    $input: UpdateVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    updateVehicle(input: $input, condition: $condition) {
      vehicleCode
      isActive
      plateNumber
      vehicleID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteVehicle = /* GraphQL */ `
  mutation DeleteVehicle(
    $input: DeleteVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    deleteVehicle(input: $input, condition: $condition) {
      vehicleCode
      isActive
      plateNumber
      vehicleID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createDriver = /* GraphQL */ `
  mutation CreateDriver(
    $input: CreateDriverInput!
    $condition: ModelDriverConditionInput
  ) {
    createDriver(input: $input, condition: $condition) {
      driverCode
      driverId
      firstName
      lastName
      recordStatus
      vehicleNeeded
      isEmployee
      allowLegacy
      allowManifest
      addWaypoint
      addLocation
      addShipment
      defaultRoute
      routeOverRide
      createManifestPickup
      allowWarehouseScan
      email
      vendor
      phoneNumber
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateDriver = /* GraphQL */ `
  mutation UpdateDriver(
    $input: UpdateDriverInput!
    $condition: ModelDriverConditionInput
  ) {
    updateDriver(input: $input, condition: $condition) {
      driverCode
      driverId
      firstName
      lastName
      recordStatus
      vehicleNeeded
      isEmployee
      allowLegacy
      allowManifest
      addWaypoint
      addLocation
      addShipment
      defaultRoute
      routeOverRide
      createManifestPickup
      allowWarehouseScan
      email
      vendor
      phoneNumber
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteDriver = /* GraphQL */ `
  mutation DeleteDriver(
    $input: DeleteDriverInput!
    $condition: ModelDriverConditionInput
  ) {
    deleteDriver(input: $input, condition: $condition) {
      driverCode
      driverId
      firstName
      lastName
      recordStatus
      vehicleNeeded
      isEmployee
      allowLegacy
      allowManifest
      addWaypoint
      addLocation
      addShipment
      defaultRoute
      routeOverRide
      createManifestPickup
      allowWarehouseScan
      email
      vendor
      phoneNumber
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateTripSheet = /* GraphQL */ `
  mutation UpdateTripSheet(
    $input: UpdateTripSheetInput!
    $condition: ModelTripSheetConditionInput
  ) {
    updateTripSheet(input: $input, condition: $condition) {
      TripSheetId
      DriverId
      RouteId
      VehicleId
      TripDate
      SignOffDate
      StartingMileage
      SignOffId
      EndingMileage
      ManifestSource
      driverCode
      routeCode
      vehicleCode
      openSince
      closedOn
      openManifestAction
      serviceStatus
      serviceTime
      lastScanTime
      costStatus
      vendor
      vendorName
      costApprovedOn
      cost
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTripSheet = /* GraphQL */ `
  mutation DeleteTripSheet(
    $input: DeleteTripSheetInput!
    $condition: ModelTripSheetConditionInput
  ) {
    deleteTripSheet(input: $input, condition: $condition) {
      TripSheetId
      DriverId
      RouteId
      VehicleId
      TripDate
      SignOffDate
      StartingMileage
      SignOffId
      EndingMileage
      ManifestSource
      driverCode
      routeCode
      vehicleCode
      openSince
      closedOn
      openManifestAction
      serviceStatus
      serviceTime
      lastScanTime
      costStatus
      vendor
      vendorName
      costApprovedOn
      cost
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAnnouncement = /* GraphQL */ `
  mutation CreateAnnouncement(
    $input: CreateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    createAnnouncement(input: $input, condition: $condition) {
      id
      header
      description
      imageBase64
      urlLink
      businessRelated
      shippingRelated
      marketingRelated
      dailyUpdateRelated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAnnouncement = /* GraphQL */ `
  mutation UpdateAnnouncement(
    $input: UpdateAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    updateAnnouncement(input: $input, condition: $condition) {
      id
      header
      description
      imageBase64
      urlLink
      businessRelated
      shippingRelated
      marketingRelated
      dailyUpdateRelated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAnnouncement = /* GraphQL */ `
  mutation DeleteAnnouncement(
    $input: DeleteAnnouncementInput!
    $condition: ModelAnnouncementConditionInput
  ) {
    deleteAnnouncement(input: $input, condition: $condition) {
      id
      header
      description
      imageBase64
      urlLink
      businessRelated
      shippingRelated
      marketingRelated
      dailyUpdateRelated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createShipment = /* GraphQL */ `
  mutation CreateShipment(
    $input: CreateShipmentInput!
    $condition: ModelShipmentConditionInput
  ) {
    createShipment(input: $input, condition: $condition) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const updateShipment = /* GraphQL */ `
  mutation UpdateShipment(
    $input: UpdateShipmentInput!
    $condition: ModelShipmentConditionInput
  ) {
    updateShipment(input: $input, condition: $condition) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const deleteShipment = /* GraphQL */ `
  mutation DeleteShipment(
    $input: DeleteShipmentInput!
    $condition: ModelShipmentConditionInput
  ) {
    deleteShipment(input: $input, condition: $condition) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      userName
      owner
      accountNo
      fullname
      userEmail
      createdBy
      createdDate
      updatedBy
      updatedDate
      location
      labelImage
      webKey
      locationID
      locationAddress {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      cloverID
      deliveryInstructions
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      ref1
      isDisabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      userName
      owner
      accountNo
      fullname
      userEmail
      createdBy
      createdDate
      updatedBy
      updatedDate
      location
      labelImage
      webKey
      locationID
      locationAddress {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      cloverID
      deliveryInstructions
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      ref1
      isDisabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      userName
      owner
      accountNo
      fullname
      userEmail
      createdBy
      createdDate
      updatedBy
      updatedDate
      location
      labelImage
      webKey
      locationID
      locationAddress {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      cloverID
      deliveryInstructions
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      ref1
      isDisabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTripSheet = /* GraphQL */ `
  mutation CreateTripSheet(
    $input: CreateTripSheetInput!
    $condition: ModelTripSheetConditionInput
  ) {
    createTripSheet(input: $input, condition: $condition) {
      TripSheetId
      DriverId
      RouteId
      VehicleId
      TripDate
      SignOffDate
      StartingMileage
      SignOffId
      EndingMileage
      ManifestSource
      driverCode
      routeCode
      vehicleCode
      openSince
      closedOn
      openManifestAction
      serviceStatus
      serviceTime
      lastScanTime
      costStatus
      vendor
      vendorName
      costApprovedOn
      cost
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTripShipment = /* GraphQL */ `
  mutation CreateTripShipment(
    $input: CreateTripShipmentInput!
    $condition: ModelTripShipmentConditionInput
  ) {
    createTripShipment(input: $input, condition: $condition) {
      tripSheetID
      shipmentIDAssignedShippingEvent
      assignedShippingEvent
      shipmentID
      activityTime
      recordedTime
      status
      statusID
      addedOn
      address {
        address1
        address2
        attention
        city
        companyName
        phone
        latitude
        longitude
        relevance
        routeCode
        state
        zipCode
        __typename
      }
      isDelivery
      isPriority
      latitude
      longitude
      timeWindowEnd
      timeWindowStart
      route
      externalTrackingNumber
      waypoint
      isPickup
      addedByUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTripShipment = /* GraphQL */ `
  mutation UpdateTripShipment(
    $input: UpdateTripShipmentInput!
    $condition: ModelTripShipmentConditionInput
  ) {
    updateTripShipment(input: $input, condition: $condition) {
      tripSheetID
      shipmentIDAssignedShippingEvent
      assignedShippingEvent
      shipmentID
      activityTime
      recordedTime
      status
      statusID
      addedOn
      address {
        address1
        address2
        attention
        city
        companyName
        phone
        latitude
        longitude
        relevance
        routeCode
        state
        zipCode
        __typename
      }
      isDelivery
      isPriority
      latitude
      longitude
      timeWindowEnd
      timeWindowStart
      route
      externalTrackingNumber
      waypoint
      isPickup
      addedByUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTripShipment = /* GraphQL */ `
  mutation DeleteTripShipment(
    $input: DeleteTripShipmentInput!
    $condition: ModelTripShipmentConditionInput
  ) {
    deleteTripShipment(input: $input, condition: $condition) {
      tripSheetID
      shipmentIDAssignedShippingEvent
      assignedShippingEvent
      shipmentID
      activityTime
      recordedTime
      status
      statusID
      addedOn
      address {
        address1
        address2
        attention
        city
        companyName
        phone
        latitude
        longitude
        relevance
        routeCode
        state
        zipCode
        __typename
      }
      isDelivery
      isPriority
      latitude
      longitude
      timeWindowEnd
      timeWindowStart
      route
      externalTrackingNumber
      waypoint
      isPickup
      addedByUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createManifestShipment = /* GraphQL */ `
  mutation CreateManifestShipment(
    $input: CreateManifestShipmentInput!
    $condition: ModelManifestShipmentConditionInput
  ) {
    createManifestShipment(input: $input, condition: $condition) {
      shipmentIDAssignedShippingEvent
      shipmentID
      assignedShippingEvent
      assignedActivities
      address {
        address1
        address2
        attention
        city
        companyName
        phone
        latitude
        longitude
        relevance
        routeCode
        state
        zipCode
        __typename
      }
      isDelivery
      isPriority
      latitude
      longitude
      route
      status
      timeWindowEnd
      timeWindowStart
      addedOn
      externalTrackingNumber
      expectedDispatchDate
      expectedDispatchTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateManifestShipment = /* GraphQL */ `
  mutation UpdateManifestShipment(
    $input: UpdateManifestShipmentInput!
    $condition: ModelManifestShipmentConditionInput
  ) {
    updateManifestShipment(input: $input, condition: $condition) {
      shipmentIDAssignedShippingEvent
      shipmentID
      assignedShippingEvent
      assignedActivities
      address {
        address1
        address2
        attention
        city
        companyName
        phone
        latitude
        longitude
        relevance
        routeCode
        state
        zipCode
        __typename
      }
      isDelivery
      isPriority
      latitude
      longitude
      route
      status
      timeWindowEnd
      timeWindowStart
      addedOn
      externalTrackingNumber
      expectedDispatchDate
      expectedDispatchTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteManifestShipment = /* GraphQL */ `
  mutation DeleteManifestShipment(
    $input: DeleteManifestShipmentInput!
    $condition: ModelManifestShipmentConditionInput
  ) {
    deleteManifestShipment(input: $input, condition: $condition) {
      shipmentIDAssignedShippingEvent
      shipmentID
      assignedShippingEvent
      assignedActivities
      address {
        address1
        address2
        attention
        city
        companyName
        phone
        latitude
        longitude
        relevance
        routeCode
        state
        zipCode
        __typename
      }
      isDelivery
      isPriority
      latitude
      longitude
      route
      status
      timeWindowEnd
      timeWindowStart
      addedOn
      externalTrackingNumber
      expectedDispatchDate
      expectedDispatchTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQueuedActivities = /* GraphQL */ `
  mutation CreateQueuedActivities(
    $input: CreateQueuedActivitiesInput!
    $condition: ModelQueuedActivitiesConditionInput
  ) {
    createQueuedActivities(input: $input, condition: $condition) {
      id
      shipmentID
      code
      description
      statusID
      shipmentStage
      shipmentPoint
      shippingEvent
      activityTime
      recordedTime
      comments
      internalComments
      notes
      tripSheetId
      latitude
      longitude
      driverCode
      routeCode
      vehicleCode
      dropBoxCode
      manifestSource
      imageKeyID
      imageKey
      ignoreActivity
      sourceData
      signedImageURL
      openManifestAction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQueuedActivities = /* GraphQL */ `
  mutation UpdateQueuedActivities(
    $input: UpdateQueuedActivitiesInput!
    $condition: ModelQueuedActivitiesConditionInput
  ) {
    updateQueuedActivities(input: $input, condition: $condition) {
      id
      shipmentID
      code
      description
      statusID
      shipmentStage
      shipmentPoint
      shippingEvent
      activityTime
      recordedTime
      comments
      internalComments
      notes
      tripSheetId
      latitude
      longitude
      driverCode
      routeCode
      vehicleCode
      dropBoxCode
      manifestSource
      imageKeyID
      imageKey
      ignoreActivity
      sourceData
      signedImageURL
      openManifestAction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQueuedActivities = /* GraphQL */ `
  mutation DeleteQueuedActivities(
    $input: DeleteQueuedActivitiesInput!
    $condition: ModelQueuedActivitiesConditionInput
  ) {
    deleteQueuedActivities(input: $input, condition: $condition) {
      id
      shipmentID
      code
      description
      statusID
      shipmentStage
      shipmentPoint
      shippingEvent
      activityTime
      recordedTime
      comments
      internalComments
      notes
      tripSheetId
      latitude
      longitude
      driverCode
      routeCode
      vehicleCode
      dropBoxCode
      manifestSource
      imageKeyID
      imageKey
      ignoreActivity
      sourceData
      signedImageURL
      openManifestAction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQueuedShipment = /* GraphQL */ `
  mutation CreateQueuedShipment(
    $input: CreateQueuedShipmentInput!
    $condition: ModelQueuedShipmentConditionInput
  ) {
    createQueuedShipment(input: $input, condition: $condition) {
      shipmentID
      queuedActivity {
        id
        shipmentID
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        dropBoxCode
        manifestSource
        imageKeyID
        imageKey
        ignoreActivity
        sourceData
        signedImageURL
        __typename
      }
      routeCode
      accountNo
      serviceAddressCompanyName
      pickupAddressCompanyName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQueuedShipment = /* GraphQL */ `
  mutation UpdateQueuedShipment(
    $input: UpdateQueuedShipmentInput!
    $condition: ModelQueuedShipmentConditionInput
  ) {
    updateQueuedShipment(input: $input, condition: $condition) {
      shipmentID
      queuedActivity {
        id
        shipmentID
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        dropBoxCode
        manifestSource
        imageKeyID
        imageKey
        ignoreActivity
        sourceData
        signedImageURL
        __typename
      }
      routeCode
      accountNo
      serviceAddressCompanyName
      pickupAddressCompanyName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQueuedShipment = /* GraphQL */ `
  mutation DeleteQueuedShipment(
    $input: DeleteQueuedShipmentInput!
    $condition: ModelQueuedShipmentConditionInput
  ) {
    deleteQueuedShipment(input: $input, condition: $condition) {
      shipmentID
      queuedActivity {
        id
        shipmentID
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        dropBoxCode
        manifestSource
        imageKeyID
        imageKey
        ignoreActivity
        sourceData
        signedImageURL
        __typename
      }
      routeCode
      accountNo
      serviceAddressCompanyName
      pickupAddressCompanyName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDepot = /* GraphQL */ `
  mutation CreateDepot(
    $input: CreateDepotInput!
    $condition: ModelDepotConditionInput
  ) {
    createDepot(input: $input, condition: $condition) {
      name
      depotCode
      latitude
      longitude
      timeWindowEnd
      timeWindowStart
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDepot = /* GraphQL */ `
  mutation UpdateDepot(
    $input: UpdateDepotInput!
    $condition: ModelDepotConditionInput
  ) {
    updateDepot(input: $input, condition: $condition) {
      name
      depotCode
      latitude
      longitude
      timeWindowEnd
      timeWindowStart
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDepot = /* GraphQL */ `
  mutation DeleteDepot(
    $input: DeleteDepotInput!
    $condition: ModelDepotConditionInput
  ) {
    deleteDepot(input: $input, condition: $condition) {
      name
      depotCode
      latitude
      longitude
      timeWindowEnd
      timeWindowStart
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTripWaypoint = /* GraphQL */ `
  mutation CreateTripWaypoint(
    $input: CreateTripWaypointInput!
    $condition: ModelTripWaypointConditionInput
  ) {
    createTripWaypoint(input: $input, condition: $condition) {
      tripSheetID
      waypoint
      address {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      arrival
      assignmentRule
      deliveries
      departure
      fromPreviousDistance
      fromPreviousTravelTime
      id
      isDelivery
      isDropBox
      latitude
      locations {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        locationID
        __typename
      }
      longitude
      pickups
      radius
      route
      sequence
      serviceTime
      shipments {
        shipmentID
        signatureRequired
        isPriority
        isDelivery
        assignedShippingEvent
        assignedActivities
        additionalServices
        __typename
      }
      stop
      stopType
      violationTime
      waitTime
      windowEnd
      windowStart
      created
      distanceCost
      endTime
      error
      geometry
      jobID
      orderCount
      overTimeCost
      processed
      regularTimeCost
      routeEnd
      routeStart
      startTime
      status
      totalBreakServiceTime
      totalCost
      totalDistance
      totalOrderServiceTime
      totalTime
      totalTravelTime
      totalViolationTime
      totalWaitTime
      violatedConstraints
      serviceCompleted
      serviceInProgress
      serviceIncomplete
      serviceStatus
      lastScanTime
      addedByUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTripWaypoint = /* GraphQL */ `
  mutation UpdateTripWaypoint(
    $input: UpdateTripWaypointInput!
    $condition: ModelTripWaypointConditionInput
  ) {
    updateTripWaypoint(input: $input, condition: $condition) {
      tripSheetID
      waypoint
      address {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      arrival
      assignmentRule
      deliveries
      departure
      fromPreviousDistance
      fromPreviousTravelTime
      id
      isDelivery
      isDropBox
      latitude
      locations {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        locationID
        __typename
      }
      longitude
      pickups
      radius
      route
      sequence
      serviceTime
      shipments {
        shipmentID
        signatureRequired
        isPriority
        isDelivery
        assignedShippingEvent
        assignedActivities
        additionalServices
        __typename
      }
      stop
      stopType
      violationTime
      waitTime
      windowEnd
      windowStart
      created
      distanceCost
      endTime
      error
      geometry
      jobID
      orderCount
      overTimeCost
      processed
      regularTimeCost
      routeEnd
      routeStart
      startTime
      status
      totalBreakServiceTime
      totalCost
      totalDistance
      totalOrderServiceTime
      totalTime
      totalTravelTime
      totalViolationTime
      totalWaitTime
      violatedConstraints
      serviceCompleted
      serviceInProgress
      serviceIncomplete
      serviceStatus
      lastScanTime
      addedByUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTripWaypoint = /* GraphQL */ `
  mutation DeleteTripWaypoint(
    $input: DeleteTripWaypointInput!
    $condition: ModelTripWaypointConditionInput
  ) {
    deleteTripWaypoint(input: $input, condition: $condition) {
      tripSheetID
      waypoint
      address {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      arrival
      assignmentRule
      deliveries
      departure
      fromPreviousDistance
      fromPreviousTravelTime
      id
      isDelivery
      isDropBox
      latitude
      locations {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        locationID
        __typename
      }
      longitude
      pickups
      radius
      route
      sequence
      serviceTime
      shipments {
        shipmentID
        signatureRequired
        isPriority
        isDelivery
        assignedShippingEvent
        assignedActivities
        additionalServices
        __typename
      }
      stop
      stopType
      violationTime
      waitTime
      windowEnd
      windowStart
      created
      distanceCost
      endTime
      error
      geometry
      jobID
      orderCount
      overTimeCost
      processed
      regularTimeCost
      routeEnd
      routeStart
      startTime
      status
      totalBreakServiceTime
      totalCost
      totalDistance
      totalOrderServiceTime
      totalTime
      totalTravelTime
      totalViolationTime
      totalWaitTime
      violatedConstraints
      serviceCompleted
      serviceInProgress
      serviceIncomplete
      serviceStatus
      lastScanTime
      addedByUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createManifestWaypoint = /* GraphQL */ `
  mutation CreateManifestWaypoint(
    $input: CreateManifestWaypointInput!
    $condition: ModelManifestWaypointConditionInput
  ) {
    createManifestWaypoint(input: $input, condition: $condition) {
      routeCode
      waypoint
      address {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      arrival
      assignmentRule
      deliveries
      departure
      fromPreviousDistance
      fromPreviousTravelTime
      id
      isDelivery
      isDropBox
      latitude
      longitude
      pickups
      radius
      route
      sequence
      serviceTime
      locations {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        locationID
        __typename
      }
      shipments {
        shipmentID
        signatureRequired
        isPriority
        isDelivery
        assignedShippingEvent
        assignedActivities
        additionalServices
        __typename
      }
      stop
      stopType
      violationTime
      waitTime
      windowEnd
      windowStart
      created
      distanceCost
      endTime
      error
      geometry
      jobID
      orderCount
      overTimeCost
      processed
      regularTimeCost
      routeEnd
      routeStart
      startTime
      status
      totalBreakServiceTime
      totalCost
      totalDistance
      totalOrderServiceTime
      totalTime
      totalTravelTime
      totalViolationTime
      totalWaitTime
      violatedConstraints
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateManifestWaypoint = /* GraphQL */ `
  mutation UpdateManifestWaypoint(
    $input: UpdateManifestWaypointInput!
    $condition: ModelManifestWaypointConditionInput
  ) {
    updateManifestWaypoint(input: $input, condition: $condition) {
      routeCode
      waypoint
      address {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      arrival
      assignmentRule
      deliveries
      departure
      fromPreviousDistance
      fromPreviousTravelTime
      id
      isDelivery
      isDropBox
      latitude
      longitude
      pickups
      radius
      route
      sequence
      serviceTime
      locations {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        locationID
        __typename
      }
      shipments {
        shipmentID
        signatureRequired
        isPriority
        isDelivery
        assignedShippingEvent
        assignedActivities
        additionalServices
        __typename
      }
      stop
      stopType
      violationTime
      waitTime
      windowEnd
      windowStart
      created
      distanceCost
      endTime
      error
      geometry
      jobID
      orderCount
      overTimeCost
      processed
      regularTimeCost
      routeEnd
      routeStart
      startTime
      status
      totalBreakServiceTime
      totalCost
      totalDistance
      totalOrderServiceTime
      totalTime
      totalTravelTime
      totalViolationTime
      totalWaitTime
      violatedConstraints
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteManifestWaypoint = /* GraphQL */ `
  mutation DeleteManifestWaypoint(
    $input: DeleteManifestWaypointInput!
    $condition: ModelManifestWaypointConditionInput
  ) {
    deleteManifestWaypoint(input: $input, condition: $condition) {
      routeCode
      waypoint
      address {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      arrival
      assignmentRule
      deliveries
      departure
      fromPreviousDistance
      fromPreviousTravelTime
      id
      isDelivery
      isDropBox
      latitude
      longitude
      pickups
      radius
      route
      sequence
      serviceTime
      locations {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        locationID
        __typename
      }
      shipments {
        shipmentID
        signatureRequired
        isPriority
        isDelivery
        assignedShippingEvent
        assignedActivities
        additionalServices
        __typename
      }
      stop
      stopType
      violationTime
      waitTime
      windowEnd
      windowStart
      created
      distanceCost
      endTime
      error
      geometry
      jobID
      orderCount
      overTimeCost
      processed
      regularTimeCost
      routeEnd
      routeStart
      startTime
      status
      totalBreakServiceTime
      totalCost
      totalDistance
      totalOrderServiceTime
      totalTime
      totalTravelTime
      totalViolationTime
      totalWaitTime
      violatedConstraints
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOAuthProviders = /* GraphQL */ `
  mutation CreateOAuthProviders(
    $input: CreateOAuthProvidersInput!
    $condition: ModelOAuthProvidersConditionInput
  ) {
    createOAuthProviders(input: $input, condition: $condition) {
      clientID
      accessToken
      accessTokenExpires
      refreshToken
      refreshTokenExpires
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOAuthProviders = /* GraphQL */ `
  mutation UpdateOAuthProviders(
    $input: UpdateOAuthProvidersInput!
    $condition: ModelOAuthProvidersConditionInput
  ) {
    updateOAuthProviders(input: $input, condition: $condition) {
      clientID
      accessToken
      accessTokenExpires
      refreshToken
      refreshTokenExpires
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOAuthProviders = /* GraphQL */ `
  mutation DeleteOAuthProviders(
    $input: DeleteOAuthProvidersInput!
    $condition: ModelOAuthProvidersConditionInput
  ) {
    deleteOAuthProviders(input: $input, condition: $condition) {
      clientID
      accessToken
      accessTokenExpires
      refreshToken
      refreshTokenExpires
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInvoice = /* GraphQL */ `
  mutation CreateInvoice(
    $input: CreateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    createInvoice(input: $input, condition: $condition) {
      invoiceID
      accountNo
      invoicePostDate
      invoiceDueDate
      taxExempt
      monthly
      invoiceURL
      remarks
      emailTo
      invoiceTotal
      invoiceTax
      invoiceFuelSurcharge
      paidSum
      credits
      paidToDate
      balance
      payment {
        paymentID
        accountNo
        paymentDate
        voucherNumber
        amount
        cardType
        expiration
        lastFour
        zipCode
        authCode
        paymentMethod
        paymentType
        deposit
        credit
        __typename
      }
      status
      summary {
        amount
        description
        fuelSurcharge
        productCode
        quantity
        serviceCode
        total
        __typename
      }
      generationStart
      generationEnd
      convenienceFee
      sequence
      billingAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      cutoffTime
      fuelSurcharge
      invoiceNo
      repriceLock
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInvoice = /* GraphQL */ `
  mutation UpdateInvoice(
    $input: UpdateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    updateInvoice(input: $input, condition: $condition) {
      invoiceID
      accountNo
      invoicePostDate
      invoiceDueDate
      taxExempt
      monthly
      invoiceURL
      remarks
      emailTo
      invoiceTotal
      invoiceTax
      invoiceFuelSurcharge
      paidSum
      credits
      paidToDate
      balance
      payment {
        paymentID
        accountNo
        paymentDate
        voucherNumber
        amount
        cardType
        expiration
        lastFour
        zipCode
        authCode
        paymentMethod
        paymentType
        deposit
        credit
        __typename
      }
      status
      summary {
        amount
        description
        fuelSurcharge
        productCode
        quantity
        serviceCode
        total
        __typename
      }
      generationStart
      generationEnd
      convenienceFee
      sequence
      billingAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      cutoffTime
      fuelSurcharge
      invoiceNo
      repriceLock
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInvoice = /* GraphQL */ `
  mutation DeleteInvoice(
    $input: DeleteInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    deleteInvoice(input: $input, condition: $condition) {
      invoiceID
      accountNo
      invoicePostDate
      invoiceDueDate
      taxExempt
      monthly
      invoiceURL
      remarks
      emailTo
      invoiceTotal
      invoiceTax
      invoiceFuelSurcharge
      paidSum
      credits
      paidToDate
      balance
      payment {
        paymentID
        accountNo
        paymentDate
        voucherNumber
        amount
        cardType
        expiration
        lastFour
        zipCode
        authCode
        paymentMethod
        paymentType
        deposit
        credit
        __typename
      }
      status
      summary {
        amount
        description
        fuelSurcharge
        productCode
        quantity
        serviceCode
        total
        __typename
      }
      generationStart
      generationEnd
      convenienceFee
      sequence
      billingAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      cutoffTime
      fuelSurcharge
      invoiceNo
      repriceLock
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInvoiceLines = /* GraphQL */ `
  mutation CreateInvoiceLines(
    $input: CreateInvoiceLinesInput!
    $condition: ModelInvoiceLinesConditionInput
  ) {
    createInvoiceLines(input: $input, condition: $condition) {
      invoiceNo
      lineNo
      accountNo
      addedOn
      additionalService
      description
      discountAmount
      tax
      discountType
      fuelSurcharge
      fuelSurchargeCode
      fuelSurchargeRate
      price
      productCode
      productFamily
      productName
      quantity
      serviceCode
      serviceNetwork
      shipmentID
      specialPrice
      total
      ref1
      ref2
      ref3
      ref4
      ref5
      pickupAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      serviceAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInvoiceLines = /* GraphQL */ `
  mutation UpdateInvoiceLines(
    $input: UpdateInvoiceLinesInput!
    $condition: ModelInvoiceLinesConditionInput
  ) {
    updateInvoiceLines(input: $input, condition: $condition) {
      invoiceNo
      lineNo
      accountNo
      addedOn
      additionalService
      description
      discountAmount
      tax
      discountType
      fuelSurcharge
      fuelSurchargeCode
      fuelSurchargeRate
      price
      productCode
      productFamily
      productName
      quantity
      serviceCode
      serviceNetwork
      shipmentID
      specialPrice
      total
      ref1
      ref2
      ref3
      ref4
      ref5
      pickupAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      serviceAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInvoiceLines = /* GraphQL */ `
  mutation DeleteInvoiceLines(
    $input: DeleteInvoiceLinesInput!
    $condition: ModelInvoiceLinesConditionInput
  ) {
    deleteInvoiceLines(input: $input, condition: $condition) {
      invoiceNo
      lineNo
      accountNo
      addedOn
      additionalService
      description
      discountAmount
      tax
      discountType
      fuelSurcharge
      fuelSurchargeCode
      fuelSurchargeRate
      price
      productCode
      productFamily
      productName
      quantity
      serviceCode
      serviceNetwork
      shipmentID
      specialPrice
      total
      ref1
      ref2
      ref3
      ref4
      ref5
      pickupAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      serviceAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrder = /* GraphQL */ `
  mutation CreateOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      accountNo
      lineNo
      addedOn
      additionalService
      description
      fuelSurcharge
      fuelSurchargeRate
      pickupAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      price
      productCode
      quantity
      serviceAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      serviceCode
      shipmentID
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrder = /* GraphQL */ `
  mutation UpdateOrder(
    $input: UpdateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    updateOrder(input: $input, condition: $condition) {
      accountNo
      lineNo
      addedOn
      additionalService
      description
      fuelSurcharge
      fuelSurchargeRate
      pickupAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      price
      productCode
      quantity
      serviceAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      serviceCode
      shipmentID
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrder = /* GraphQL */ `
  mutation DeleteOrder(
    $input: DeleteOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    deleteOrder(input: $input, condition: $condition) {
      accountNo
      lineNo
      addedOn
      additionalService
      description
      fuelSurcharge
      fuelSurchargeRate
      pickupAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      price
      productCode
      quantity
      serviceAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      serviceCode
      shipmentID
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPayment = /* GraphQL */ `
  mutation CreatePayment(
    $input: CreatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    createPayment(input: $input, condition: $condition) {
      paymentID
      accountNo
      paymentDate
      voucherNumber
      amount
      cardType
      expiration
      lastFour
      zipCode
      invoice {
        invoiceID
        accountNo
        invoicePostDate
        invoiceDueDate
        taxExempt
        monthly
        remarks
        emailTo
        invoiceTotal
        invoiceTax
        invoiceFuelSurcharge
        paidSum
        credits
        paidToDate
        balance
        __typename
      }
      authCode
      paymentMethod
      paymentType
      deposit
      credit
      checkNo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePayment = /* GraphQL */ `
  mutation UpdatePayment(
    $input: UpdatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    updatePayment(input: $input, condition: $condition) {
      paymentID
      accountNo
      paymentDate
      voucherNumber
      amount
      cardType
      expiration
      lastFour
      zipCode
      invoice {
        invoiceID
        accountNo
        invoicePostDate
        invoiceDueDate
        taxExempt
        monthly
        remarks
        emailTo
        invoiceTotal
        invoiceTax
        invoiceFuelSurcharge
        paidSum
        credits
        paidToDate
        balance
        __typename
      }
      authCode
      paymentMethod
      paymentType
      deposit
      credit
      checkNo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePayment = /* GraphQL */ `
  mutation DeletePayment(
    $input: DeletePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    deletePayment(input: $input, condition: $condition) {
      paymentID
      accountNo
      paymentDate
      voucherNumber
      amount
      cardType
      expiration
      lastFour
      zipCode
      invoice {
        invoiceID
        accountNo
        invoicePostDate
        invoiceDueDate
        taxExempt
        monthly
        remarks
        emailTo
        invoiceTotal
        invoiceTax
        invoiceFuelSurcharge
        paidSum
        credits
        paidToDate
        balance
        __typename
      }
      authCode
      paymentMethod
      paymentType
      deposit
      credit
      checkNo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCloverCardOnFile = /* GraphQL */ `
  mutation CreateCloverCardOnFile(
    $input: CreateCloverCardOnFileInput!
    $condition: ModelCloverCardOnFileConditionInput
  ) {
    createCloverCardOnFile(input: $input, condition: $condition) {
      cloverID
      cloverCardID
      userName
      accountNo
      cardExpires
      expireOn
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCloverCardOnFile = /* GraphQL */ `
  mutation UpdateCloverCardOnFile(
    $input: UpdateCloverCardOnFileInput!
    $condition: ModelCloverCardOnFileConditionInput
  ) {
    updateCloverCardOnFile(input: $input, condition: $condition) {
      cloverID
      cloverCardID
      userName
      accountNo
      cardExpires
      expireOn
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCloverCardOnFile = /* GraphQL */ `
  mutation DeleteCloverCardOnFile(
    $input: DeleteCloverCardOnFileInput!
    $condition: ModelCloverCardOnFileConditionInput
  ) {
    deleteCloverCardOnFile(input: $input, condition: $condition) {
      cloverID
      cloverCardID
      userName
      accountNo
      cardExpires
      expireOn
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createActivities = /* GraphQL */ `
  mutation CreateActivities(
    $input: CreateActivitiesInput!
    $condition: ModelActivitiesConditionInput
  ) {
    createActivities(input: $input, condition: $condition) {
      code
      description
      statusID
      shipmentStage
      shipmentPoint
      shippingEvent
      activityTime
      recordedTime
      comments
      internalComments
      notes
      tripSheetId
      latitude
      longitude
      driverCode
      routeCode
      vehicleCode
      dropBoxCode
      manifestSource
      imageKeyID
      imageKey
      customerVisible
      openManifestAction
      notifyType
      isBillable
      productTemplate {
        serviceCode
        productCode
        description
        orderMode
        canExclude
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateActivities = /* GraphQL */ `
  mutation UpdateActivities(
    $input: UpdateActivitiesInput!
    $condition: ModelActivitiesConditionInput
  ) {
    updateActivities(input: $input, condition: $condition) {
      code
      description
      statusID
      shipmentStage
      shipmentPoint
      shippingEvent
      activityTime
      recordedTime
      comments
      internalComments
      notes
      tripSheetId
      latitude
      longitude
      driverCode
      routeCode
      vehicleCode
      dropBoxCode
      manifestSource
      imageKeyID
      imageKey
      customerVisible
      openManifestAction
      notifyType
      isBillable
      productTemplate {
        serviceCode
        productCode
        description
        orderMode
        canExclude
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteActivities = /* GraphQL */ `
  mutation DeleteActivities(
    $input: DeleteActivitiesInput!
    $condition: ModelActivitiesConditionInput
  ) {
    deleteActivities(input: $input, condition: $condition) {
      code
      description
      statusID
      shipmentStage
      shipmentPoint
      shippingEvent
      activityTime
      recordedTime
      comments
      internalComments
      notes
      tripSheetId
      latitude
      longitude
      driverCode
      routeCode
      vehicleCode
      dropBoxCode
      manifestSource
      imageKeyID
      imageKey
      customerVisible
      openManifestAction
      notifyType
      isBillable
      productTemplate {
        serviceCode
        productCode
        description
        orderMode
        canExclude
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSignature = /* GraphQL */ `
  mutation CreateSignature(
    $input: CreateSignatureInput!
    $condition: ModelSignatureConditionInput
  ) {
    createSignature(input: $input, condition: $condition) {
      id
      signedBy
      isNJLSSigned
      writeURL
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSignature = /* GraphQL */ `
  mutation UpdateSignature(
    $input: UpdateSignatureInput!
    $condition: ModelSignatureConditionInput
  ) {
    updateSignature(input: $input, condition: $condition) {
      id
      signedBy
      isNJLSSigned
      writeURL
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSignature = /* GraphQL */ `
  mutation DeleteSignature(
    $input: DeleteSignatureInput!
    $condition: ModelSignatureConditionInput
  ) {
    deleteSignature(input: $input, condition: $condition) {
      id
      signedBy
      isNJLSSigned
      writeURL
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUPSTrackingQueue = /* GraphQL */ `
  mutation CreateUPSTrackingQueue(
    $input: CreateUPSTrackingQueueInput!
    $condition: ModelUPSTrackingQueueConditionInput
  ) {
    createUPSTrackingQueue(input: $input, condition: $condition) {
      shipmentID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateUPSTrackingQueue = /* GraphQL */ `
  mutation UpdateUPSTrackingQueue(
    $input: UpdateUPSTrackingQueueInput!
    $condition: ModelUPSTrackingQueueConditionInput
  ) {
    updateUPSTrackingQueue(input: $input, condition: $condition) {
      shipmentID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteUPSTrackingQueue = /* GraphQL */ `
  mutation DeleteUPSTrackingQueue(
    $input: DeleteUPSTrackingQueueInput!
    $condition: ModelUPSTrackingQueueConditionInput
  ) {
    deleteUPSTrackingQueue(input: $input, condition: $condition) {
      shipmentID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createShipmentStageManager = /* GraphQL */ `
  mutation CreateShipmentStageManager(
    $input: CreateShipmentStageManagerInput!
    $condition: ModelShipmentStageManagerConditionInput
  ) {
    createShipmentStageManager(input: $input, condition: $condition) {
      shipmentID
      currentShipmentStage
      shipmentStageTTL
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateShipmentStageManager = /* GraphQL */ `
  mutation UpdateShipmentStageManager(
    $input: UpdateShipmentStageManagerInput!
    $condition: ModelShipmentStageManagerConditionInput
  ) {
    updateShipmentStageManager(input: $input, condition: $condition) {
      shipmentID
      currentShipmentStage
      shipmentStageTTL
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteShipmentStageManager = /* GraphQL */ `
  mutation DeleteShipmentStageManager(
    $input: DeleteShipmentStageManagerInput!
    $condition: ModelShipmentStageManagerConditionInput
  ) {
    deleteShipmentStageManager(input: $input, condition: $condition) {
      shipmentID
      currentShipmentStage
      shipmentStageTTL
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createVendorActivityMapping = /* GraphQL */ `
  mutation CreateVendorActivityMapping(
    $input: CreateVendorActivityMappingInput!
    $condition: ModelVendorActivityMappingConditionInput
  ) {
    createVendorActivityMapping(input: $input, condition: $condition) {
      vendorID
      vendorCode
      activityStatusID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateVendorActivityMapping = /* GraphQL */ `
  mutation UpdateVendorActivityMapping(
    $input: UpdateVendorActivityMappingInput!
    $condition: ModelVendorActivityMappingConditionInput
  ) {
    updateVendorActivityMapping(input: $input, condition: $condition) {
      vendorID
      vendorCode
      activityStatusID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteVendorActivityMapping = /* GraphQL */ `
  mutation DeleteVendorActivityMapping(
    $input: DeleteVendorActivityMappingInput!
    $condition: ModelVendorActivityMappingConditionInput
  ) {
    deleteVendorActivityMapping(input: $input, condition: $condition) {
      vendorID
      vendorCode
      activityStatusID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLookups = /* GraphQL */ `
  mutation CreateLookups(
    $input: CreateLookupsInput!
    $condition: ModelLookupsConditionInput
  ) {
    createLookups(input: $input, condition: $condition) {
      pk
      sk
      information
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLookups = /* GraphQL */ `
  mutation UpdateLookups(
    $input: UpdateLookupsInput!
    $condition: ModelLookupsConditionInput
  ) {
    updateLookups(input: $input, condition: $condition) {
      pk
      sk
      information
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLookups = /* GraphQL */ `
  mutation DeleteLookups(
    $input: DeleteLookupsInput!
    $condition: ModelLookupsConditionInput
  ) {
    deleteLookups(input: $input, condition: $condition) {
      pk
      sk
      information
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPlaceAddress = /* GraphQL */ `
  mutation CreatePlaceAddress(
    $input: CreatePlaceAddressInput!
    $condition: ModelPlaceAddressConditionInput
  ) {
    createPlaceAddress(input: $input, condition: $condition) {
      placeID
      secondaryPlaceID
      latitude
      longitude
      relevance
      address1
      city
      state
      zipCode
      placeCode
      geoHash3
      primaryPlace
      needsReview
      serviceAddressType
      isDropBox
      operatorTitle
      timeWindowStart
      timeWindowEnd
      timeWindowType
      createdAt
      updatedAt
      addressCorrected
      originalAddress
      category
      addrType
      strucType
      strucDet
      esriMatchID
      esriRooftopLatitude
      esriRooftopLongitude
      esriStreetSideLatitude
      esriStreetSideLongitude
      esriScore
      esriAddrType
      esriFormattedAddress
      esriStrucType
      esriStrucDet
      esriExtentXmin
      esriExtentYmin
      esriExtentXmax
      esriExtentYmax
      esriShortLabel
      esriLongLabel
      esriPlaceName
      esriPlaceAddr
      esriPhone
      esriUrl
      esriType
      esriUnitType
      esriUnitName
      esriSubAddr
      esriStAddr
      esriCity
      esriRegion
      esriRegionAbbr
      esriPostal
      esriPostalExt
      esriDisplayX
      esriDisplayY
      esriX
      esriY
      __typename
    }
  }
`;
export const updatePlaceAddress = /* GraphQL */ `
  mutation UpdatePlaceAddress(
    $input: UpdatePlaceAddressInput!
    $condition: ModelPlaceAddressConditionInput
  ) {
    updatePlaceAddress(input: $input, condition: $condition) {
      placeID
      secondaryPlaceID
      latitude
      longitude
      relevance
      address1
      city
      state
      zipCode
      placeCode
      geoHash3
      primaryPlace
      needsReview
      serviceAddressType
      isDropBox
      operatorTitle
      timeWindowStart
      timeWindowEnd
      timeWindowType
      createdAt
      updatedAt
      addressCorrected
      originalAddress
      category
      addrType
      strucType
      strucDet
      esriMatchID
      esriRooftopLatitude
      esriRooftopLongitude
      esriStreetSideLatitude
      esriStreetSideLongitude
      esriScore
      esriAddrType
      esriFormattedAddress
      esriStrucType
      esriStrucDet
      esriExtentXmin
      esriExtentYmin
      esriExtentXmax
      esriExtentYmax
      esriShortLabel
      esriLongLabel
      esriPlaceName
      esriPlaceAddr
      esriPhone
      esriUrl
      esriType
      esriUnitType
      esriUnitName
      esriSubAddr
      esriStAddr
      esriCity
      esriRegion
      esriRegionAbbr
      esriPostal
      esriPostalExt
      esriDisplayX
      esriDisplayY
      esriX
      esriY
      __typename
    }
  }
`;
export const deletePlaceAddress = /* GraphQL */ `
  mutation DeletePlaceAddress(
    $input: DeletePlaceAddressInput!
    $condition: ModelPlaceAddressConditionInput
  ) {
    deletePlaceAddress(input: $input, condition: $condition) {
      placeID
      secondaryPlaceID
      latitude
      longitude
      relevance
      address1
      city
      state
      zipCode
      placeCode
      geoHash3
      primaryPlace
      needsReview
      serviceAddressType
      isDropBox
      operatorTitle
      timeWindowStart
      timeWindowEnd
      timeWindowType
      createdAt
      updatedAt
      addressCorrected
      originalAddress
      category
      addrType
      strucType
      strucDet
      esriMatchID
      esriRooftopLatitude
      esriRooftopLongitude
      esriStreetSideLatitude
      esriStreetSideLongitude
      esriScore
      esriAddrType
      esriFormattedAddress
      esriStrucType
      esriStrucDet
      esriExtentXmin
      esriExtentYmin
      esriExtentXmax
      esriExtentYmax
      esriShortLabel
      esriLongLabel
      esriPlaceName
      esriPlaceAddr
      esriPhone
      esriUrl
      esriType
      esriUnitType
      esriUnitName
      esriSubAddr
      esriStAddr
      esriCity
      esriRegion
      esriRegionAbbr
      esriPostal
      esriPostalExt
      esriDisplayX
      esriDisplayY
      esriX
      esriY
      __typename
    }
  }
`;
